export default __webpack_public_path__ + "static/media/BiraCarvalho_04.2633e5a9.jpg";